export const locale = {
    lang: 'fr',
    data: {
        PROJECTS_SESSION_NEW_DIALOG_CREATE_SESSION: 'Créer un atelier',
        PROJECTS_SESSION_NEW_DIALOG_GENERAL: 'Général',
        PROJECTS_SESSION_NEW_DIALOG_MEMBERS: 'Membres'
    }
};
